import React from "react";
import { Box, Button, Typography } from "@mui/material";
import { useTheme } from "@mui/material";

const UpdateNotification = ({ open, onRefresh }) => {
  const theme = useTheme();

  if (!open) return null;
  
  return (
    <Box
      sx={{
        width: "100%",
        backgroundColor: theme.palette.info.main,
        color: theme.palette.primary.text,
        display: "flex",
        flexWrap: "wrap",
        alignItems: "center",
        justifyContent: "center",
        py: "12px",
        px: { xs: 2, sm: 3 },
        columnGap: 3,
        rowGap: 1,
        boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
      }}
    >
      <Typography
        variant="body1"
        sx={{ fontWeight: 500, color: theme.palette.background.alt }}
      >
        🎉 A new version of CE Portal is available!
      </Typography>
      <Button
        variant="contained"
        size="small"
        onClick={onRefresh}
        sx={{
          backgroundColor: theme.palette.background.alt,
          color: theme.palette.info.main,
          fontWeight: "bold",
          "&:hover": {
            backgroundColor: theme.palette.background.default,
          },
        }}
      >
        RELOAD NOW
      </Button>
    </Box>
  );
};

export default UpdateNotification;
